<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="fee.id > 0; else addTitle">Edit Fee</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <p class="mat-form-field--inline">
        <mat-form-field class="edit-fee__fee-type">
          <mat-select placeholder="Type *" [(value)]="selectedDescription" name="description" formControlName="description">
            <mat-option *ngFor="let type of feeTypes" [value]="type">{{ type }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-radio-group formControlName="feeRadio">
          <mat-radio-button (click)="feeChargedClick()" value="FeeCharged">Fee Charged</mat-radio-button>
          <mat-radio-button (click)="feeNotChargedClick()" value="FeeNotCharged">Fee Not Charged</mat-radio-button>
          <mat-radio-button (click)="feeNotDisclosedClick()" value="FeeNotDisclosed">Fee Not Disclosed</mat-radio-button>
        </mat-radio-group>
      </p>
      <p class="mat-form-field--inline">
      <mat-form-field>
        <span matPrefix>$</span>
        <input matInput
               placeholder="Fee *"
               formControlName="fee"
               [(ngModel)]="selectedFee">
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Fee Basis *" [(value)]="selectedFeeBasis" (selectionChange)="feeBasisChanged()" name="feeBasis" formControlName="feeBasis">
          <mat-option *ngFor="let basis of feeBasisVals" [value]="basis">{{ basis }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Aircraft Type *" [(value)]="selectedAircraftType" name="aircraftType" formControlName="aircraftType">
          <mat-option *ngFor="let aircraftType of aircraftTypes" [value]="aircraftType">{{ aircraftType }}</mat-option>
        </mat-select>
      </mat-form-field>
      </p>
      <p class="mat-form-field--inline">
        <mat-form-field>
          <input matInput placeholder="Note" formControlName="note" [(ngModel)]="selectedNote" type="text">
        </mat-form-field>
      </p>
      <p class="mat-form-field--inline">
      <mat-checkbox id='waiverCheckbox' [(ngModel)]="selectedWaiver" formControlName="waiver">Fuel Purchase Waiver?</mat-checkbox>
        <mat-form-field class="edit-fee__waiver-fuel">
          <input matInput
                 placeholder="Waiver Fuel Quantity (in Gallons) *"
                 formControlName="waiverFuelQty"
                 [attr.disabled]="!selectedWaiver ? '' : null"
                 [(ngModel)]="selectedWaiverFuelQty">
        </mat-form-field>
      </p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Fee
</ng-template>
